import { useApplicantAPI } from "@certn/api";
import { useAuth } from "@certn/auth";

export function useUser() {
  const { user, isLoading, isAuthenticated } = useAuth();
  const { data: details, mutate } = useApplicantAPI(
    isAuthenticated ? "/api/internal/applicant/me/" : null
  );

  return {
    user,
    details,
    refresh: mutate,
    isLoading,
  };
}
